import React from 'react';
import { useIntl } from 'react-intl';

import * as S from './FreeTextContent.styles';
import { messages } from './messages';

const ButtonWithTranslation = () => {
  const { formatMessage } = useIntl();

  return (
    <S.StyledButton className='ot-sdk-show-settings' id='ot-sdk-btn'>
      {formatMessage(messages.cookieDashboardButton)}
    </S.StyledButton>
  );
};

export default ButtonWithTranslation;
